import type { DateTime } from '@ksyos/date-time';
import type { IProcess } from 'common/interfaces/IProcess';
import type { IProcessAction } from 'common/interfaces/IProcessAction';
import type { InsuranceHistory } from 'common/interfaces/patientInsurance';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { thunk } from 'redux-thunk';
import type { IRequest } from '../common/interfaces/IRequest';
import type { IAuthenticatedUser } from '../common/utils/IAuthenticatedUser';
import type { IAuthenticationState, IUserPermissions } from './store/authentication/reducers';
import type { ILanguageState } from './store/language/reducers';
import { rootReducer as authenticationRootReducer } from './store/authentication/reducers';
import { rootReducer as languageRootReducer } from './store/language/reducers';

function logger() {
    return (next: any) => (action: any) => {
        const returnValue = next(action);

        return returnValue;
    };
}

function configureStore(initialState: any) {
    return composeWithDevTools(applyMiddleware(thunk, logger))(createStore as any)(
        combineReducers({
            authentication: authenticationRootReducer,
            language: languageRootReducer,
        }),
        initialState
    );
}

export const store = configureStore({});

export interface IReduxState {
    authentication: ISessionUser;
    language: ILanguageState;
}

export interface IMaybeLoggedInReduxState {
    authentication: IAuthenticationState;
    language: ILanguageState;
}

export interface ISessionUser {
    actions?: IProcessAction[];
    id: string;
    insurance?: InsuranceHistory;
    loggedIn: boolean;
    permissions?: IUserPermissions;
    processes?: IProcess[];
    requestProcesses?: IRequest[];
    sessionTimeout?: DateTime;
    token: string;
    user?: IAuthenticatedUser;
    userHasOsasMraReferralLetter?: boolean;
}
